import { apiClient } from "~/api/ApiClient";
import { PAGE_TITLES } from "~/configs/pageTitles";

import ExportsPage from "../ExportsPage/ExportsPage";

const SiteSalesReports = () => (
  <ExportsPage
    exportType="SiteSalesReport"
    createFn={(siteId) => apiClient.sites.salesReportsCreate(siteId)}
    pageTitle={PAGE_TITLES.siteSalesReports}
    description='Click "Run New Export" to create a PDF overview of your site, keywords and recommendations.'
    successMessage="Site sales report is generating"
    emptyText="Create your first site sales report to get started."
  />
);

export default SiteSalesReports;
